import { DeleteRequestfe } from "../../../apis/Requrment"



export default function PendingRequrment(params) {


    return <>
      {
        params.Data.data.map(item=>{
          return (item.adminstatus!="approved"||item.hrstatus!="approved"||item.adminstatus!="rejected"||item.hrstatus!="rejected")&&item.user.department=="Human Resource"?<div class="task-card ui-sortable-handle">
          <div class="progress">
            <div class="progress-bar bg-warning" role="progressbar" style={{width: '100%'}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <div class="d-flex justify-content-between mb-3">
            <div>
              <p class="text-muted">{item.created_date}</p>
              <h4 class="task-title">{item.title}</h4>
              <p class="task-body">{item.description}</p>
            </div>
            <div class="dropdown">
              <button type="button" class="dropdown-toggle" id="portlet-action-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="typcn typcn-arrow-sorted-dow"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="portlet-action-dropdown" >
                <a class="dropdown-item" href="#">Edit</a>
                <button class="dropdown-item" onClick={()=>DeleteRequestfe(item.id)} >Delete</button>
              </div>
            </div>
          </div>
          <div class="image-grouped">
            <img src={"https://erpsystem.darakoutlet.com"+item.user.profileimage} alt="profile image"/>
          </div>
          
                     <div class="d-flex justify-content-between align-items-center mt-2">
            {
              item.hrstatus=="pending"?<div class="badge badge-success badge-sm">Pending HR Administrator</div>:<div class="badge badge-info badge-sm">Pending CEO Approval</div>
              
              
            }
          </div>
        </div>:<></>
        })
      }
    </>
}